import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
     primary: {
      main: "#1B5E20",   // Deep forest green (core compost identity)
      light: "#4CAF50",
      dark: "#0B3D14",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#2E7D32",   // Clean sustainability green
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F4F7F5",  // soft neutral – no yellow nonsense
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1F2933",
      secondary: "#4B5563",
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          padding: "8px 20px",
        },
      },
    },
     MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#1B5E20",
          color: "#FFFFFF",
        },
      },
    },

        MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "14px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        },
      },
    },
  },
});

export default theme;
